import styled, { css } from 'styled-components';

export const ReportWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`;

export const SectionCard = styled.div`
    width: 100%;
    background-color: var(--color-white);
    border-radius: var(--box-border-radius);
    padding:24px 30px;
    border-bottom: none;

    &:last-child {
        border-bottom: none;
    }

    @media (max-width: 768px) {
        padding: 20px;
    }
`;

export const SectionHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
`;

export const SectionTitle = styled.h2`
    font-size: 16px;
    font-weight: 600;
    color: var(--color-primary);
    margin: 0;
`;

export const TextContent = styled.p`
    font-size: var(--font-size-body-2);
    font-weight: 500;
    color: var(--color-primary-70);
    line-height: 1.6;
    margin: 0 0 16px;
    text-align: justify;
`;

export const ParamChip = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 5px;
    background: var(--background-color-ai);
    border-radius: 6px;
    padding: 5px 10px;
    font-size: var(--font-size-body-3);
    font-weight: 600;
    color: var(--color-primary);
`;

export const FeatureChip = styled.span<{ active?: boolean }>`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border-radius: 6px;
    padding: 5px 10px;
    font-size: var(--font-size-body-3);
    font-weight: 500;
    ${({ active }) => active
        ? css`
            background: var(--color-success-background);
            color: var(--color-success);
            border: 1px solid var(--color-success);
        `
        : css`
            background: var(--color-alt-second);
            color: var(--color-primary-70);
            border: 1px solid var(--color-alt-second);
        `}
`;

export const CheckboxIcon = styled.span<{ active?: boolean }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 14px;
    height: 14px;
    border-radius: 3px;
    font-size: 10px;
    font-weight: 700;
    flex-shrink: 0;
    ${({ active }) => active
        ? css`
            background: var(--color-success);
            color: var(--color-white);
        `
        : css`
            background: var(--color-alt-second-10);
            color: var(--color-primary-70);
        `}
`;
